/**
 * useAficionVisitanteTheater — predicado de elegibilidad del modal "Afición visitante".
 *
 * Centraliza la regla que decide si el modal informativo de afición visitante
 * debe mostrarse. El PR anterior dejaba el hash literal dentro de la vista de
 * compra, mezclando política de negocio con infraestructura del modal. Esta
 * ubicación única permite que vistas, scripts y tests compartan una sola fuente
 * de verdad y que el magic string nunca se filtre a los consumidores.
 *
 * Diseño:
 *   - `AFICION_VISITANTE_TEATRO_HASH` se exporta como constante para que los
 *     tests y otros módulos puedan afirmar contra la fuente de verdad sin
 *     hardcodear el hash de nuevo.
 *   - `AFICION_VISITANTE_MODAL_NAME` se exporta para evitar repetir el nombre
 *     del modal cada vez que la vista lo abre o lo cierra.
 *   - `isAficionVisitanteTheater(teatroHash)` es un predicado puro: recibe el
 *     hash del teatro y devuelve un booleano. Esto permite usarlo tanto desde
 *     Options API como desde Composition API sin depender de `getCurrentInstance`.
 */

/**
 * Hash del teatro para el cual aplica el aviso de afición visitante.
 * @type {string}
 */
export const AFICION_VISITANTE_TEATRO_HASH = 'PSaG3BjUboDrGdZz6SQq';

/**
 * Nombre del modal en vue-js-modal para abrir/cerrar el aviso.
 * @type {string}
 */
export const AFICION_VISITANTE_MODAL_NAME = 'aficion-visitante';

/**
 * Predicado puro que decide si el modal aplica para un teatro dado.
 *
 * @param {string|null|undefined} teatroHash - hash del teatro actual
 * @returns {boolean} true cuando el teatro es el objetivo del aviso
 */
export function isAficionVisitanteTheater(teatroHash) {
    return teatroHash === AFICION_VISITANTE_TEATRO_HASH;
}
